import SEO from '../../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import SpecComparison from './components/SpecComparison';
import PointComparison from './components/PointComparison';
import SuitableFor from './components/SuitableFor';
import Conclusion from './components/Conclusion';
import Footer from './components/Footer';
import Breadcrumb from '../../../components/feature/Breadcrumb';

export default function RakutenVsMitsuiArticlePage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        headline: '大手ECモール系vs三井住友カード徹底比較｜どっちがお得？',
        description: '大手ECモール系カードと三井住友カード（NL）を徹底比較。年会費、還元率、特典、審査難易度など8項目で比較し、あなたに最適なカードを見つけるための選び方を詳しく解説します。',
        author: {
          '@type': 'Organization',
          name: 'クレジットカード比較'
        },
        datePublished: '2026-01-01',
        dateModified: new Date().toISOString().split('T')[0],
        image: 'https://public.readdy.ai/ai/img_res/62f43ea7dc372ee581ec6779118caef5.jpg'
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'ホーム',
            item: 'https://yourdomain.com/'
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '記事一覧',
            item: 'https://yourdomain.com/#articles'
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: '大手ECモール系vs三井住友カード',
            item: 'https://yourdomain.com/articles/rakuten-vs-mitsui'
          }
        ]
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="大手ECモール系vs三井住友カード徹底比較｜どっちがお得？"
        description="大手ECモール系カードと三井住友カード（NL）を徹底比較。年会費、還元率、特典、審査難易度など8項目で比較し、あなたに最適なカードを見つけるための選び方を詳しく解説します。"
        keywords="大手ECモール系カード,三井住友カード,比較,どっち,おすすめ,違い,選び方"
        canonicalUrl="https://yourdomain.com/articles/rakuten-vs-mitsui"
        ogImage="https://readdy.ai/api/search-image?query=two%20premium%20credit%20cards%20side%20by%20side%20comparison%20rakuten%20red%20and%20mitsui%20sumitomo%20green%20modern%20design%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20detailed%20sharp%20focus&width=1200&height=630&seq=rakuten-vs-mitsui-og&orientation=landscape"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: '記事一覧', path: '/#articles' },
        { label: '大手ECモール系vs三井住友カード' }
      ]} />
      <Hero />
      <SpecComparison />
      <PointComparison />
      <SuitableFor />
      <Conclusion />
      <Footer />
    </div>
  );
}
